<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Azzkcf/tc-custom/9781614235217.jpg?1688952708133" alt="This image is the cover for the book Shenandoah County in the Civil War, Civil War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shenandoah County in the Civil War, Civil War Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Shenandoah County, in the years prior to the Civil War, was a prosperous place. Nestled within the Shenandoah Valley, it was a haven for agricultural commerce fueled by slave labor. Integral railways and transportation routes passed through Shenandoah County, feeding its impressive agricultural output throughout the Virginia. With the outbreak of Civil War, all of that would change. Four major battles took place in and around Shenandoah County New Market, Toms Brook, Fishers Hill, and Cedar Creek. Although the proceedings of these historic battles have been well-documented, the effect the combat had on residents of Shenandoah County has receded into the background. Now, author Hal Shape brings the lives of county residents to fore, recounting how their spirits were tested during this dark hour of American history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hal F. Sharpe
      </h2>
      
      <p class="authorDescription body article">Hal Sharpe is a retired forensic scientist and criminal investor with the United States Army who resides with his wife in Edinburg, Virginia. Sharpe has a master's degree in history from Austin Peay State University in Clarksville, Tennessee, and a master's of forensic sciences from George Washington University in Washington, D.C. As a longtime student of Civil War history, particularly in the Shenandoah Valley, Mr. Sharpe has served as a member of the board of directors for the Shenandoah County Historical Society and the Edinburg Heritage Foundation. He served as a member of the historical interpretation committee of the Shenandoah Battlefield Foundation. He is the founding commander of the Captain Jack Adams Camp of the Sons of Confederate Veterans. He is also the author of numerous articles and parts of books related to the Civil War in the Shenandoah Valley.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a12bccc